import React, { useState } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
// import Fab from "@material-ui/core/Fab";
import IconButton from "@material-ui/core/IconButton";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import MicIcon from "@material-ui/icons/Mic";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
// import BallotIcon from "@material-ui/icons/Ballot";
// import Attachment from "@material-ui/icons/Attachment";
import CameraIcon from "@material-ui/icons/Camera";
import PostAddIcon from "@material-ui/icons/PostAdd";
// import ImageIcon from "@material-ui/icons/Image";

export default function PrescriptionFab({
  shot,
  medicalDocuments,
  medicalInstructions,
  handleOpenFileUploadDialog,
  handleOpenVoiceRecorderDialog,
  handleOpenVideoeRecorderDialog,
  handleOpenCompressedImageDialog,
  setAttachType,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <div className="send-files" onClick={handleClick} style={{ justifyContent: 'center' }}>
        {/* <div className="send-svg-files" style={{ width: '100%' }}>
          <svg viewBox="0 0 512 512">
            <path d="M493.87 95.6L416.4 18.13C404.32 6.04 388.48 0 372.64 0c-15.84 0-31.68 6.04-43.76 18.13l-92.45 92.45-99.83 28.21a64.003 64.003 0 00-43.31 41.35L0 460l52 52 279.86-93.29a64.003 64.003 0 0041.35-43.31l28.21-99.83 92.45-92.45c24.17-24.17 24.17-63.35 0-87.52zM327.02 362.35c-1.44 5.1-5.31 9.15-10.34 10.83L83.83 450.79 187.42 347.2c6.26 2.99 13.18 4.8 20.58 4.8 26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48c0 7.4 1.81 14.32 4.8 20.58L61.21 428.17l77.62-232.85c1.68-5.03 5.72-8.89 10.83-10.34l99.83-28.21 1.05-.3 105 105-.29 1.04-28.23 99.84zm132.91-213.17l-74.41 74.41-97.11-97.11 74.41-74.41c2.29-2.29 11.67-7.97 19.64 0l77.47 77.47c5.42 5.41 5.42 14.22 0 19.64z" />
          </svg>{" "}
        </div> */}
        {/* <AttachFileSharpIcon style={{ fontSize: 16 }} /> */}
        {/* <img style={{ fontSize: 16, width:100}} src={TripleIcon} /> */}
        <span>ارسال نسخه</span>
      </div>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          style={{ padding: '8px 0px 8px 32px' }}
          onClick={() => {
            shot();
            setAttachType();
            handleClose()
          }}
        >
          <IconButton aria-haspopup="true">
            <CameraIcon style={styles.btn} titleAccess="ارسال فایل" />
          </IconButton>
          <div style={{ width: '100%', textAlign: 'right' }}>
            عکس برداری از دستورات
          </div>

        </MenuItem>

        <MenuItem
          style={{ padding: '8px 0px 8px 32px' }}
          onClick={() => {
            handleOpenFileUploadDialog();
            setAttachType();
            handleClose()
          }}
        >
          <IconButton aria-haspopup="true">
            <AttachFileIcon style={styles.btn} titleAccess="ارسال فایل" />
          </IconButton>
          <div style={{ width: '100%', textAlign: 'right' }}>
            ضمیمه کردن دستورات
          </div>

        </MenuItem>

        <MenuItem
          style={{ padding: '8px 0px 8px 32px' }}
          onClick={() => {
            handleOpenVoiceRecorderDialog();
            setAttachType();
            handleClose()
          }}
        >
          <IconButton aria-haspopup="true">
            <MicIcon style={styles.btn} titleAccess="ارسال فایل صوتی" />
          </IconButton>
          <div style={{ width: '100%', textAlign: 'right' }}>
            ضبط فایل صوتی دستورات
          </div>

        </MenuItem>
        {/* <MenuItem
          style={{ padding: '8px 0px 8px 32px' }}
          onClick={() => {
            handleOpenVideoeRecorderDialog();
            setAttachType();
            handleClose()
          }}
        >
          <IconButton aria-haspopup="true">
            <CameraAltIcon style={styles.btn} titleAccess="ارسال پیام تصویری" />
          </IconButton>
          <div style={{ width: '100%', textAlign: 'right' }}>
            پیام ویدیویی
          </div>
        </MenuItem> */}
        <MenuItem
          style={{ padding: '8px 0px 8px 32px' }}
          onClick={() => {
            window.open("https://ep.tamin.ir", "_blank");
          }}
        >
          <IconButton aria-haspopup="true">
            <PostAddIcon
              style={styles.btn}
              titleAccess="نسخه الکترونیک تامین اجتماعی"
            />
          </IconButton>
          <div style={{ width: '100%', textAlign: 'right', paddingLeft: 0 }}>
            نسخه الکترونیک تامین اجتماعی
          </div>
        </MenuItem>

        <MenuItem
          style={{ padding: '8px 0px 8px 32px' }}
          onClick={() => {
            window.open("https://eservices.ihio.gov.ir/ihioerx/", "_blank");
          }}
        >
          <IconButton >
            <PostAddIcon style={styles.btn} titleAccess="نسخه الکترونیک بیمه سلامت" />
          </IconButton>
          <div style={{ width: '100%', textAlign: 'right' }}>
            نسخه الکترونیک بیمه سلامت
          </div>
        </MenuItem>
      </Menu>
    </div>
  );
}

const styles = {
  btn: {
    fontSize: 25,
    color: "#7144B7",
  },
  btnColor: { backgroundColor: "#7144B7", color: "white" },
};
